export const remainderSteps = [
  {
    element: '#reminderview',
    popover: {
      title: 'View Surgery‐Related Reminders ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li>Each reminder includes the message text and the scheduled day offset (S+2, S‐1, etc).</li> </ul></div>',
    },
  },

  // {
  //     element: '#editdeletereminder',
  //     popover: {
  //     title: 'Edit/Delete Reminders ',
  //     showButtons: ['previous', 'next', 'close'],
  //     description: '<div><ul><li>edit or delete existing ones as needed.</li></ul></div>'
  //     },

  // },
  {
    element: '#addreminder',
    popover: {
      title: 'Add reminder ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Add a new reminder at the bottom. </li></ul></div>',
    },
  },
  {
    element: '#reminderfilter',
    popover: {
      title: 'Filter by Surgery Type ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Icons in the Action column may let you reply, forward, or mark messages as reviewed.</li></ul></div>',
    },
  },
]
